<template>
  <div class="actions">
    <div class="wallet-balance">
      <span class="wallet-icon">$</span>
      <span class="wallet-amount">{{ authUser.user.balance }}</span>
      <button class="deposit-btn" v-on:click="modalsSetShow('Cashier')">
        <PlusIcon class="plus-icon" />
        <span class="deposit-icon">
          <DepositDotIcon />
        </span>
        <span> Deposit </span>
      </button>
    </div>

    <!-- Notification -->
    <button class="icon-btn">
      <NotificationIcon />
    </button>

    <!-- Profile -->
    <div class="profile-cont">
      <button class="icon-btn profile" v-on:click="chatToggleDropdown">
        <UserIcon />
      </button>
      <div
        class="dropdown-menu"
        v-bind:class="{ 'dropdown-open': dropdownOpen === true }"
      >
        <router-link v-on:click.native="navbarSetDropdown(false)" to="/profile">
          <!-- <IconUser /> -->
          Profile
        </router-link>
        <button v-on:click="navbarVaultButton()" class="button-room">
          <IconVault />
          Vault
        </button>
        <router-link v-on:click.native="navbarSetDropdown(false)" to="/rewards">
          <IconRakeback />
          Rewards
        </router-link>
        <router-link
          v-on:click.native="navbarSetDropdown(false)"
          to="/affiliates"
        >
          <IconAffiliates />
          Affliiates
        </router-link>
        <router-link
          v-on:click.native="navbarSetDropdown(false)"
          to="/leaderboard"
        >
          <IconLeaderboard />
          Leaderboard
        </router-link>
        <router-link
          v-if="authUser.user.rank === 'admin'"
          v-on:click.native="navbarSetDropdown(false)"
          to="/admin"
        >
          <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path
              d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"
            />
          </svg> -->
          Admin
        </router-link>
        <button v-on:click="navbarLogoutButton()" class="button-room">
          <IconSignOut />
          Sign out
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserIcon from "@/components/icons/UserIcon";
import NotificationIcon from "@/components/icons/NotificationIcon";
import DepositDotIcon from "@/components/icons/DepositDotIcon.vue";
import IconUser from "@/components/icons/IconUser.vue";
import PlusIcon from "@/components/icons/PlusIcon.vue";

export default {
  name: "UserSection",
  components: {
    UserIcon,
    NotificationIcon,
    DepositDotIcon,
    IconUser,
    PlusIcon,
  },

  data() {
    return {
      dropdownOpen: false,
    };
  },
  methods: {
    ...mapActions(["modalsSetShow", "authLogoutUser"]),
    chatToggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    navbarSetDropdown(value) {
      this.navbarDropdown = value;
    },
    navbarVaultButton() {
      this.modalsSetShow("Vault");
      this.navbarSetDropdown(false);
    },
    navbarLogoutButton() {
      this.navbarSetDropdown(false);
      this.authLogoutUser();
    },
  },
  computed: {
    ...mapGetters(["authUser"]),
  },
  created() {
    let self = this;
    document.addEventListener("click", function (event) {
      if (!self.$el.contains(event.target) && self.dropdownOpen == true) {
        self.chatToggleDropdown();
      }
    });
  },
};
</script>

<style scoped>
.actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.dropdown-menu {
  position: absolute;
  top: 60px;
  right: 0;
  flex-direction: column;
  gap: 10px;
  background-color: rgb(36 36 40);
  border-radius: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: none;
}

.button-room {
  display: flex;
  gap: 5px;
  color: rgb(121 121 134);
  font-weight: 600;
  font-size: 1rem;
  padding: 0.5rem;
}

.dropdown-menu a {
  display: flex;
  gap: 5px;
  color: rgb(121 121 134);

  font-weight: 800;
  font-size: 1rem;
  padding: 0.5rem;
}

.dropdown-menu.dropdown-open {
  display: flex;
}

.dropdown-menu a:hover {
  background-color: hsla(0, 0%, 100%, 0.06);
}

.button-room:hover {
  background-color: hsla(0, 0%, 100%, 0.06);
}

.wallet-balance {
  display: flex;
  align-items: center;
  background: #1c1c1e; /* dark pill background */
  border-radius: 9999px;
  padding: 0.25rem 0.5rem;
  gap: 10px;
  border: 2px solid rgb(38 38 43);
  background-color: rgb(36 36 40);
}

.wallet-icon {
  background: #d6c68a; /* gold circle for $ */
  color: #000;
  font-weight: bold;
  border-radius: 50%;
  padding: 4px 8px;
  font-size: 14px;
}

.wallet-amount {
  font-weight: 600;
  color: #fff;
}

.deposit-btn {
  display: flex;
  align-items: center;
  font-weight: 600;
  border: none;
  border-radius: 9999px;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  height: 2.5rem;
  cursor: pointer;
  transition: background 0.3s ease;
  border: 2px solid rgb(19 87 77);
  background-color: rgb(15 80 70);
  color: rgb(255 255 255);
}

.deposit-btn:hover {
  background: #047857; /* lighter green */
}

.deposit-icon {
  margin-right: 6px;
  font-size: 10px;
}

.icon-btn {
  border: 2px solid rgb(38 38 43);
  background-color: rgb(36 36 40);
  border-radius: 50%;
  border: none;
  width: 45px;
  height: 45px;
  color: #d6c68a;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile {
  border: 2px solid #d6c68a; /* gold border */
}

.profile-cont {
  position: relative;
}

.plus-icon {
  display: none;
}
@media only screen and (max-width: 640px) {
  .profile-cont {
    display: none;
  }
  .deposit-btn span {
    display: none;
  }
  .plus-icon {
    display: block;
  }
}
</style>
